import clsx from "clsx";
import React from "react";
import { useTranslation } from "react-i18next";
import { ButtonOpenMenu } from "./ButtonOpenMenu";

export const DocumentParameters = ({ config, isOpen, setIsOpen, onClose }) => {
  const { t } = useTranslation();

  return (
    <div className="preview-area">
      <div className="preview-header">
        <h3>{t("preview.title")}</h3>
        <button onClick={onClose} className="preview-close-btn" type="button">
          {t("preview.close")}
        </button>
      </div>
      <div className="px-2 py-2 md:px-4 preview-content">
        <div className="flex justify-between">
          <div className="mb-4 w-full text-lg font-semibold text-center">
            {t("preview.header")}
          </div>
          <ButtonOpenMenu isOpen={isOpen} setIsOpen={setIsOpen} />
        </div>

        <div
          className={clsx("grid grid-cols-3 gap-2 mt-2 md:gap-4", {
            hidden: !isOpen,
          })}
        >
          {/* Colonne 1 - Base */}
          <div className="space-y-2">
            <div className="mb-3 text-sm font-semibold text-primary-600">
              {t("preview.sections.base")}
            </div>
            <div className="space-y-1 text-xs">
              <div>
                <span className="font-medium">
                  {t("preview.labels.version")}
                </span>{" "}
                {config.version || "2024"}
              </div>
              <div>
                <span className="font-medium">
                  {t("preview.labels.language")}
                </span>{" "}
                {config.lang || "fr"}
              </div>
              <div>
                <span className="font-medium">
                  {t("preview.labels.preset")}
                </span>{" "}
                {config.configPreset || t("preview.values.custom")}
              </div>
            </div>
          </div>

          {/* Colonne 2 - Format */}
          <div className="space-y-2">
            <div className="mb-3 text-sm font-semibold text-primary-600">
              {t("preview.sections.format")}
            </div>
            <div className="space-y-1 text-xs">
              <div>
                <span className="font-medium">{t("preview.labels.paper")}</span>{" "}
                {config.paperFormat || "A4"}
              </div>
              <div>
                <span className="font-medium">
                  {t("preview.labels.orientation")}
                </span>{" "}
                {config.orientation || "portrait"}
              </div>
              <div>
                <span className="font-medium">
                  {t("preview.labels.columns")}
                </span>{" "}
                {config.columnCount || 1}
              </div>
            </div>
          </div>

          {/* Colonne 3 - Contenu */}
          <div className="space-y-2">
            <div className="mb-3 text-sm font-semibold text-primary-600">
              {t("preview.sections.content")}
            </div>
            <div className="space-y-1 text-xs">
              <div>
                <span className="font-medium">
                  {t("preview.labels.procedures")}
                </span>{" "}
                {config.includeProcedures !== false
                  ? t("preview.values.yes")
                  : t("preview.values.no")}
              </div>
              <div>
                <span className="font-medium">
                  {t("preview.labels.examples")}
                </span>{" "}
                {config.includeExamples !== false
                  ? t("preview.values.yes")
                  : t("preview.values.no")}
              </div>
              {config.includeExamples !== false && (
                <div>
                  <span className="font-medium">
                    {t("preview.labels.examples")}
                  </span>{" "}
                  {config.examples?.inline !== false
                    ? t("preview.values.inline")
                    : t("preview.values.annexe")}
                </div>
              )}
              <div>
                <span className="font-medium">{t("preview.labels.index")}</span>{" "}
                {config.includeIndex === true
                  ? t("preview.values.yes")
                  : t("preview.values.no")}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DocumentParameters;
